export function formatCurrency(value: number, currencyCode: string): string {
  if(typeof value != "number" || !currencyCode) {
    throw new Error("Value and currency code are required");
  }
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol"
  }).format(value);
}